import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import StarAnimation from "../../assets/Animation - 1749015219630.json";
import Lottie from "lottie-react";
import "./thanksPage.css";

const ThanksPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handlePopState = () => {
      navigate("/", { replace: true });
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [navigate]);

  return (
    <section className="thanksPage">
      <div className="thanksPage-container container">
        <div className="thanks-header">
          <h2>شكرا لوقتك!</h2>
        </div>
        <div className="thanks-star">
          <Lottie animationData={StarAnimation} loop={true} />
        </div>
        <div className="thanks-footer">
          <p>
            ملاحظاتك تساهم بشكل كبير في تحسين خدماتنا وتقديم تجربة أفضل لك
            ولجميع عملائنا.
          </p>
          <p>نحن نقدر ثقتك ونسعد دائمًا بخدمتك.</p>
        </div>
      </div>
    </section>
  );
};

export default ThanksPage;
